import Text from "common/Typography/Text";
import Modal from "common/Modal/Modal";
import useCancelSubscriptionModal from "@shared/features/settings/subscription/hooks/useCancelSubscriptionModal";
import { displayResultMessage } from "utils/misc";
import { CancelSubscriptionModalProps } from "@shared/features/settings/subscription/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const CancelSubscriptionModal = ({
  visible,
  closeModal,
}: CancelSubscriptionModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  const {
    isLoadingCancelSubscription,
    onCancelSubscriptionClick,
    modalContent,
  } = useCancelSubscriptionModal({
    closeModal,
    displayResultMessage,
  });

  return (
    <Modal
      open={visible}
      onCancel={closeModal}
      title={t("cancel_subscription_modal.title")}
      destroyOnHidden={true}
      okText={t("cancel_subscription_modal.yes")}
      onOk={() => {
        onCancelSubscriptionClick();
      }}
      okButtonProps={{ loading: isLoadingCancelSubscription }}
      cancelButtonProps={{ disabled: isLoadingCancelSubscription }}
    >
      <div style={{ rowGap: 8 }}>
        {modalContent.map((string, index) => (
          <Text key={index} style={{ marginTop: index !== 0 ? 8 : 0 }}>
            {string}
          </Text>
        ))}
      </div>
    </Modal>
  );
};

export default CancelSubscriptionModal;
